<template>
    <div class="contact-us">
        <div class="contact-banner"></div>
        <div class="main-box">
            <h4 class="big-title">商务洽谈</h4>
            <p class="title">手机号</p>
            <p class="cont">15931215125(同步微信)</p>
            <p class="title">企业邮箱</p>
            <p class="cont">chenkang@beimen.com</p>
        </div>
        <div class="line"></div>
        <div class="main-box">
            <h4 class="big-title">联系我们</h4>
            <p class="title">公司地址</p>
            <p class="cont">河北省保定市涿州市冠云东路保鑫国际大厦13层</p>
            <p class="title">企业邮箱</p>
            <p class="cont">chenkang@beimen.com</p>
            <!-- 
            <p class="title">公司电话</p>
            <p class="cont">010-82425430</p>
            <p class="title">公司传真</p>
            <p class="cont">010-82425430</p>
            -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactUs',
}
</script>

<style lang="scss" scoped>
.contact-us {
    padding-top: 88px;

    .big-title {
        font-size: 30px;
        color: #222;
        margin-bottom: 48px;
        font-weight: bold;
    }

    .title {
        font-size: 26px;
        color: #535353;
        margin-bottom: 26px;
        letter-spacing: 1px;
    }

    .cont {
        font-size: 22px;
        color: #999;
        margin-bottom: 52px;
        letter-spacing: 1px;
    }

    .line {
        height: 10px;
        background: #F7F7F7;
    }

    .contact-banner {
        height: 120px;
        background: url('../assets/img/banner@2.png') no-repeat;
        background-size: 100% 100%;
    }

    .main-box {
        padding: 54px;
    }
}
</style>